<template>
  <div class="filters">
    <template v-if="selectedColumn">
      <div class="filter-row" v-if="selectedColumn.type === 'input'">
        <v-text-field
          :label="selectedColumn.label"
          :placeholder="selectedColumn.label"
          outlined
          dense
          hide-details
          @input="onChangeDebounced"
        />

        <v-btn text @click="onRemoveFilter" small> Ta bort </v-btn>
      </div>
    </template>
    <v-menu offset-y v-if="!selectedColumn" max-height="400">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text @click="onRemoveFilter" small> Ta bort </v-btn>
        <v-btn text v-bind="attrs" v-on="on" small> Välj nyckel </v-btn>
      </template>
      <v-list>
        <v-list-item
          dense
          v-for="(item, index) in filterOptions"
          :key="index"
          link
          @click="onSelectFilter(item)"
        >
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { debounce } from '@/lib/misc'
import { options } from '@/assets/data/contactOptions.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    seltectTags: [],
  }),
  created() {
    this.onChangeDebounced = debounce((value) => {
      this.$emit('change', { ...this.filter, value })
    }, 300)
  },
  computed: {
    ...mapGetters('contacts', { tags: 'tags' }),

    filterOptions() {
      return options
    },

    selectedColumn() {
      return this.filterOptions.find((option) => option.key === this.filter.key)
    },
  },
  methods: {
    onSelectFilter(option) {
      this.$emit('change', { ...this.filter, ...option })
    },
    onRemoveFilter() {
      this.$emit('remove', this.filter)
    },
    onChangeTags() {
      if (!this.seltectTags.length) {
        this.$emit('remove', this.filter)
        return
      }
      this.$emit('change', { ...this.filter, value: [this.seltectTags] })
    },
  },
}
</script>

<style lang="less" scoped>
.filters {
  display: flex;
  // border-radius: 4px;
  // border: 1px solid rgb(76, 175, 80);
  padding: 8px 0px;
  .filter-row {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
